import React, { useContext, useEffect } from 'react';
import { useRouter } from 'next/router';
import { HELPCENTER_URL, HELPCENTER_AUTH_DOMAIN } from 'apiUrls';
import {
  fetchZendeskToken,
  ZendeskTokenError,
} from 'components/templates/AuthenticationProvider/authApiUtils';
import { AuthenticationContext } from 'components/templates/AuthenticationProvider/AuthenticationProvider';
import useQueryStringParams from 'hooks/useQueryStringParams';
import LoadingScreen from 'components/atoms/LoadingScreen/LoadingScreen';

export interface Props {
  link?: string;
}

const HELPCENTER_LINKS = {
  helpcenter: '',
  requests: '/requests',
  new: '/requests/new?ticket_form_id=360000147548',
};
type HelpCenterLinkKey = keyof typeof HELPCENTER_LINKS;

const Entry: React.FC<Props> = () => {
  const { link } = useQueryStringParams();
  const { accessToken, isLoggedIn } = useContext(AuthenticationContext);
  const { locale = 'en-US' } = useRouter();
  const helpCenterUrl =
    HELPCENTER_URL +
    '/hc/' +
    locale.toLowerCase() +
    (link in HELPCENTER_LINKS ? HELPCENTER_LINKS[link as HelpCenterLinkKey] : '') +
    (link !== 'new' ? '?' : '&') +
    'source=kpp';

  useEffect(() => {
    fetchZendeskToken(accessToken, locale).then(
      (token) => {
        const destination = token.length
          ? HELPCENTER_AUTH_DOMAIN +
            '/access/jwt?jwt=' +
            token +
            '&return_to=' +
            encodeURI(helpCenterUrl)
          : helpCenterUrl;

        window.location.replace(destination);
      },
      (reason) => {
        console.warn(`Unexpected Zendesk token error ${reason}`);
        window.location.replace(helpCenterUrl);
      },
    );
  }, [accessToken, isLoggedIn]);

  return <LoadingScreen />;
};
export default Entry;
